// extracted by mini-css-extract-plugin
export default {"root":"MbCs0","nowrap":"wBPpy","b2bLink":"_9PHAt"};